import React from 'react';
import { LegalDocument } from '../components/legal/LegalDocument';

export const DataDeletionPage: React.FC = () => {
  return (
    <LegalDocument
      documentPath="/legal/data-deletion.md"
      title="Data Deletion Policy"
      description="How to request deletion of your personal data from the admeru platform."
    />
  );
};
